// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/city_categories.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { CityCategoryService } from "./city_categories_pb";

/**
 * ListCityCategories returns every category with its active-POI count for the
 * given city, in display order.
 *
 * @generated from rpc travplaces.v1.CityCategoryService.ListCityCategories
 */
export const listCityCategories = CityCategoryService.method.listCityCategories;
